module.exports = __webpack_public_path__ + "pc/img/body_basic 10.9244d4cd.jpg";